import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';
import VueApexCharts from 'vue-apexcharts';
import VueLocalStorage from 'vue-localstorage';
import Notifications from 'vue-notification';
import VueRouter from 'vue-router';
import VueClipboard from 'vue-clipboard2';

import vuetify from './plugins/vuetify';
import App from './App.vue';
import { routes } from './routes';
import { AuthService } from './services';
import store, { ACTIONS } from './store';
import { fetchConstants } from './api';
import { MatcherTaskVersion } from './constants/task';

import './sass/status-colors.scss';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader

const $v = (item, path, defaultValue) => _.get(item, path, defaultValue);

Vue.use(Vuex);
Vue.use(VueClipboard);
Vue.use(VueRouter);
Vue.use(VueLocalStorage);
Vue.use(Notifications);
Vue.use(VueApexCharts);
Vue.prototype.$v = $v;

Vue.component('apexchart', VueApexCharts);

const router = new VueRouter({
  mode: 'history',
  routes
});

const vueStore = store();

const initStore = async () => {
  const constants = await fetchConstants();
  vueStore.dispatch(ACTIONS.SET_CONSTANTS, constants);
};

router.beforeEach((to, from, next) => {
  const isRequiredAuth = to.matched.some((record) => record.meta.requiresAuth);
  const isCustomerLink = to.matched.some((record) => record.meta.customerLink);

  // Need feature toggle constants before rendering
  initStore().then(() => {
    if (isRequiredAuth && !AuthService.checkLogin() && !isCustomerLink) {
      next({ name: 'Login' });
    } else if (AuthService.checkLogin() && to.name === 'Login') {
      next({ name: 'Tasks' });
    } else if (isCustomerLink) {
      // Override Matcher API feature toggle version based on customer path property
      vueStore.commit('setFeatureToggleEnabled', {
        name: 'matcher_api_v2',
        enabled: to.params.matcherVersion === MatcherTaskVersion.V2
      });
      next();
    } else {
      next();
    }
  });
});

Vue.config.productionTip = false;

export const VRouter = router;

new Vue({
  router,
  vuetify,
  store: vueStore,
  render: (h) => h(App)
}).$mount('#app');
